import { render, staticRenderFns } from "./RequestCustomerForm.vue?vue&type=template&id=56329bca&scoped=true"
import script from "./RequestCustomerForm.vue?vue&type=script&lang=js"
export * from "./RequestCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./RequestCustomerForm.vue?vue&type=style&index=0&id=56329bca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56329bca",
  null
  
)

export default component.exports